// extracted by mini-css-extract-plugin
export default {"button":"learningStatus_button__SnXVP","buttonLearned":"learningStatus_buttonLearned__7iMZR","buttonLink":"learningStatus_buttonLink__gNGML","badge":"learningStatus_badge__7KUXd"};